export default "__VITE_ASSET__Y9B_6loH__"